import Vue from "vue";
import Vuex from "vuex";
import VueRouter from "vue-router";
import VueI18n from "vue-i18n";

import Vuetify, { VTabs, VTab, VTabsItems, VTabItem, VTabsSlider, VSnackbar, VOverlay, VForm, VTextField, VApp, VProgressCircular, VTextarea, VCheckbox } from "vuetify/lib";
import { Ripple } from "vuetify/lib/directives";
import VCalendar from "v-calendar";

import VueCurrencyFilter from 'vue-currency-filter'

import "./dragscroll";
import "./scrollable";

import messages from "./messages.js";
import store from "./store";
import './filters';

Vue.use(VueI18n);
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(VCalendar);

Vue.use(Vuetify, {
    components: {
        VTabs,
        VTab,
        VTabsItems,
        VTabItem,
        VTabsSlider,
        VSnackbar,
        VOverlay,
        VForm,
        VTextField,
        VApp,
        VProgressCircular,
        VTextarea,
        VCheckbox
    },
    directives: {
        Ripple
    }
});

const vuetify = new Vuetify({});

import HeaderComponent from "./components/layouts/header.vue";
import FooterComponent from "./components/layouts/footer.vue";
import MenuWrapper from "./components/menu/MenuWrapper.vue";
import BookTable from "./components/wizard/BookTable.vue";
import PersonalData from "./components/wizard/PersonalData.vue";
import Comfirmed from "./components/wizard/Comfirmed.vue";
import Gallery from "./components/gallery/Gallery.vue";
import GallerySlider from "./components/gallery/GallerySlider.vue";
import GalleryHomePageController from "./components/gallery/GalleryHomePageController.vue";
import FloatingInput from "./components/form/FloatingInput.vue";
import FloatingTextarea from "./components/form/FloatingTextarea.vue";

Vue.component("header-component", HeaderComponent);
Vue.component("footer-component", FooterComponent);
Vue.component("menu-wrapper", MenuWrapper);
Vue.component("gallery", Gallery);
Vue.component("gallery-slider", GallerySlider);
Vue.component("gallery-home-page-controller", GalleryHomePageController);
Vue.component("floating-input", FloatingInput);
Vue.component("floating-textarea", FloatingTextarea);

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: window.appLocale, // set locale
    messages // set locale messages
});

// Vue Currency Filter
Vue.use(VueCurrencyFilter, {
    symbol: "€",
    thousandsSeparator: ".",
    fractionCount: 2,
    fractionSeparator: ",",
    symbolPosition: "back",
    symbolSpacing: true,
    avoidEmptyDecimals: undefined,
});

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        // {
        //     path: "/:lang/:reserve/tipo",
        //     component: TypeTable,
        //     name: "type-table"
        // },
        {
            path: "/:lang/:reserve/mesa",
            component: BookTable,
            name: "book-table"
        },
        {
            path: "/:lang/:reserve/personal",
            component: PersonalData,
            name: "personal-data"
        },
        {
            path: "/:lang/:reserve/comfirmed",
            component: Comfirmed,
            name: "comfirmed"
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});

var app = new Vue({
    el: "#app",
    store,
    i18n,
    vuetify,
    router
});
